import { VerticalDotsIcon } from "assets/icons";
import { IconButton, TableItemActionsModal } from "ui";

import { TableItemActionsControlProps } from "./TableItemActionsControl.types";

import styles from "./TableItemActionsControl.module.scss";

const TableItemActionsControl = ({
  openedItemOptionsIndex,
  setOpenedItemOptionsIndex,
  rowIndex,
  actionsList
}: TableItemActionsControlProps) => {
  return (
    <div className={styles.actionsControlContainer}>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          if (openedItemOptionsIndex === null) {
            setOpenedItemOptionsIndex(rowIndex);
          } else {
            setOpenedItemOptionsIndex(null);
          }
        }}
        icon={<VerticalDotsIcon />}
      />

      {openedItemOptionsIndex === rowIndex ? (
        <TableItemActionsModal
          handleClose={() => setOpenedItemOptionsIndex(null)}
          actionsList={actionsList}
        />
      ) : null}
    </div>
  );
};
export default TableItemActionsControl;
